import { LuPlus } from 'react-icons/lu';
import { Button } from '@/components/Button';
import type { CustomCategory } from '../api/useFetchCustomCategories';

interface CategoryTabsProps {
  categories: CustomCategory[];
  selectedCategoryId: number | null;
  onSelectCategory: (categoryId: number) => void;
  onAddCategory: () => void;
}

export default function CategoryTabs({
  categories,
  selectedCategoryId,
  onSelectCategory,
  onAddCategory,
}: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-4 border-b border-gray-300 pb-1">
      {/* タブ */}
      <div className="flex items-center">
        {categories.map((category) => {
          const isSelected = category.id === selectedCategoryId;
          return (
            <button
              key={category.id}
              onClick={() => onSelectCategory(category.id)}
              className={`relative flex h-11 items-center justify-center rounded-t px-6 text-sm transition ${
                isSelected ? 'font-bold' : 'font-normal hover:bg-gray-50'
              }`}
              style={{
                borderBottom: isSelected ? '2px solid #005FFF' : '1px solid #D1D1D1',
                color: isSelected ? '#005FFF' : '#262626',
              }}
            >
              {category.name}
            </button>
          );
        })}
      </div>

      {/* 区分を追加ボタン */}
      <Button color="secondary" size="md" onClick={onAddCategory}>
        <LuPlus size={20} />
        区分を追加
      </Button>
    </div>
  );
}
